"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSystemStyles = exports.FONT_STYLE_EMPHASIS_LIGHT_ITALIC = exports.FONT_STYLE_EMPHASIS_LIGHT = exports.FONT_STYLE_EMPHASIS_DEFAULT = exports.FONT_STYLE_REGULAR_BOLD_ITALIC = exports.FONT_STYLE_REGULAR_BOLD = exports.FONT_STYLE_REGULAR_LIGHT_ITALIC = exports.FONT_STYLE_REGULAR_LIGHT = exports.FONT_STYLE_REGULAR_DEFAULT = exports.FONT_STYLE_DISPLAY_BLACK = exports.FONT_STYLE_DISPLAY_DEFAULT = void 0;

var _styledComponents = require("styled-components");

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-weight: ", ";\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        ", ";\n        font-style: italic;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-weight: ", ";\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        font-style: italic;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        ", ";\n        font-style: italic;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-weight: ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-weight: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-weight: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-weight: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-weight: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-weight: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var FONT_STYLE_DISPLAY_DEFAULT = 'displayDefault';
exports.FONT_STYLE_DISPLAY_DEFAULT = FONT_STYLE_DISPLAY_DEFAULT;
var FONT_STYLE_DISPLAY_BLACK = 'displayBlack';
exports.FONT_STYLE_DISPLAY_BLACK = FONT_STYLE_DISPLAY_BLACK;
var FONT_STYLE_REGULAR_DEFAULT = 'regularDefault';
exports.FONT_STYLE_REGULAR_DEFAULT = FONT_STYLE_REGULAR_DEFAULT;
var FONT_STYLE_REGULAR_LIGHT = 'regularLight';
exports.FONT_STYLE_REGULAR_LIGHT = FONT_STYLE_REGULAR_LIGHT;
var FONT_STYLE_REGULAR_LIGHT_ITALIC = 'regularLightItalic';
exports.FONT_STYLE_REGULAR_LIGHT_ITALIC = FONT_STYLE_REGULAR_LIGHT_ITALIC;
var FONT_STYLE_REGULAR_BOLD = 'regularBold';
exports.FONT_STYLE_REGULAR_BOLD = FONT_STYLE_REGULAR_BOLD;
var FONT_STYLE_REGULAR_BOLD_ITALIC = 'regularBoldItalic';
exports.FONT_STYLE_REGULAR_BOLD_ITALIC = FONT_STYLE_REGULAR_BOLD_ITALIC;
var FONT_STYLE_EMPHASIS_DEFAULT = 'emphasisDefault';
exports.FONT_STYLE_EMPHASIS_DEFAULT = FONT_STYLE_EMPHASIS_DEFAULT;
var FONT_STYLE_EMPHASIS_LIGHT = 'emphasisLight';
exports.FONT_STYLE_EMPHASIS_LIGHT = FONT_STYLE_EMPHASIS_LIGHT;
var FONT_STYLE_EMPHASIS_LIGHT_ITALIC = 'emphasisLightItalic';
exports.FONT_STYLE_EMPHASIS_LIGHT_ITALIC = FONT_STYLE_EMPHASIS_LIGHT_ITALIC;

var regularLight = function regularLight(props) {
  return (0, _styledComponents.css)(_templateObject(), props.theme.fontSystem.regular.fontFamily, props.theme.fontSystem.regular.light.fontWeight);
};

var regularBold = function regularBold(props) {
  return (0, _styledComponents.css)(_templateObject2(), props.theme.fontSystem.regular.fontFamily, props.theme.fontSystem.regular.bold.fontWeight);
};

var emphasisLight = function emphasisLight(props) {
  return (0, _styledComponents.css)(_templateObject3(), props.theme.fontSystem.emphasis.fontFamily, props.theme.fontSystem.emphasis.light.fontWeight);
};

var fontSystemStyles = function fontSystemStyles(props) {
  switch (props.fontStyle) {
    case FONT_STYLE_DISPLAY_DEFAULT:
      return (0, _styledComponents.css)(_templateObject4(), props.theme.fontSystem.display.fontFamily, props.theme.fontSystem.display.default.fontWeight);

    case FONT_STYLE_DISPLAY_BLACK:
      return (0, _styledComponents.css)(_templateObject5(), props.theme.fontSystem.display.fontFamily, props.theme.fontSystem.display.black.fontWeight);

    case FONT_STYLE_REGULAR_DEFAULT:
      return (0, _styledComponents.css)(_templateObject6(), props.theme.fontSystem.regular.fontFamily, props.theme.fontSystem.regular.default.fontWeight);

    case FONT_STYLE_REGULAR_LIGHT:
      return regularLight;

    case FONT_STYLE_REGULAR_LIGHT_ITALIC:
      return (0, _styledComponents.css)(_templateObject7(), regularLight);

    case FONT_STYLE_REGULAR_BOLD:
      return regularBold;

    case FONT_STYLE_REGULAR_BOLD_ITALIC:
      return (0, _styledComponents.css)(_templateObject8(), regularBold);

    case FONT_STYLE_EMPHASIS_DEFAULT:
      return (0, _styledComponents.css)(_templateObject9(), props.theme.fontSystem.emphasis.fontFamily, props.theme.fontSystem.emphasis.default.fontWeight);

    case FONT_STYLE_EMPHASIS_LIGHT:
      return emphasisLight;

    case FONT_STYLE_EMPHASIS_LIGHT_ITALIC:
      return (0, _styledComponents.css)(_templateObject10(), emphasisLight);

    default:
      return (0, _styledComponents.css)(_templateObject11(), props.theme.defaultFontFamily, props.theme.fontSystem.regular.default.fontWeight);
  }
};

exports.fontSystemStyles = fontSystemStyles;